module.exports = __webpack_public_path__ + "img/placeholder.b099c09a.png";